import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/event-applications', config);
};

const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/event-applications/excel-export', {
        ...config,
        responseType: 'blob'
    });
};

const approveAll = async (eventId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/coop/events/' + eventId + '/applications/approve-all');
};

const approveSelected = async (ids) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/coop/event-applications/approve-selected', { ids });
};

const updateStatus = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/coop/event-applications/' + id + '/status', data);
};

const remove = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/coop/event-applications/' + id);
};

const apply = async (eventId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/coop/events/' + eventId + '/apply');
};

const getMe = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/event-applications/me', config);
};

export default {
    getAll,
    excelExport,
    approveAll,
    approveSelected,
    updateStatus,
    remove,
    apply,
    getMe
};

